import { createEvent } from 'effector'

export const setSelected = createEvent()

export const setQty = createEvent()

export const getProduct = createEvent()

export const resetProduct = createEvent()